exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2AF-lTMn ._3YQ8PYnM{text-align:center;font-weight:700;border:1px solid transparent;border-radius:8px;font-style:italic;font-size:12px;line-height:16px;padding:8px 15px;display:block}._2AF-lTMn ._3YQ8PYnM._14cwKljT{background:#BC373714 14;color:#741E1ECE CE;border-color:#BC37373C 3c}._2AF-lTMn ._3YQ8PYnM.s631_1li{color:#bc3737;background:#ffd9d9;border-color:#bc3737}._2AF-lTMn ._3YQ8PYnM._1uiN4f1V{color:#414141;background:#BC373714 14;border-color:#BC37373C 3c}._2AF-lTMn._18lj7VT-{display:block;margin-bottom:12px}._2AF-lTMn._1dOs0u6Q{display:block;margin:8px 16px}", ""]);

// exports
exports.locals = {
	"component-deadline": "_2AF-lTMn",
	"text": "_3YQ8PYnM",
	"urgency-just-show": "_14cwKljT",
	"urgency-alarm": "s631_1li",
	"urgency-unknown": "_1uiN4f1V",
	"filter": "_18lj7VT-",
	"flyover": "_1dOs0u6Q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/question/deadlineLabel/style.less
// module id = 1267
// module chunks = 1